import React, { useCallback } from 'react';
import moment from 'moment';
import DayPickerInput from 'react-day-picker/DayPickerInput';
// for react-day-picker translations
// https://react-day-picker-v7.netlify.app/docs/localization
import MomentLocaleUtils from 'react-day-picker/moment';
import { injectIntl } from 'react-intl';

const FORMAT = 'YYYY-MM-DD';
const UI_FORMAT = 'D MMM YYYY';
const FILTER_FIELD = 'date';

const t = {
  select_date: 'Select date',
};

const formatDate = (value) => {
  return moment(value).format(UI_FORMAT);
};

const DateFilter = ({ filters, onChange, width, intl }) => {
  const handleChange = useCallback(
    (v) => {
      if (!onChange) {
        return;
      }

      const formattedValue = moment(v).format(FORMAT);

      onChange({ [FILTER_FIELD]: formattedValue });
    },
    [onChange]
  );

  const { [FILTER_FIELD]: value } = filters || {};

  const placeholder = t.select_date;

  return (
    <div className="filter" style={{ width }}>
      <DayPickerInput
        localeUtils={MomentLocaleUtils}
        locale={intl.locale}
        value={value ? moment(value).toDate() : value}
        placeholder={placeholder}
        formatDate={formatDate}
        onDayChange={handleChange}
        className="field"
      />
    </div>
  );
};

export default injectIntl(DateFilter);
